import type { RefreshControlProps } from 'react-native'
import { RefreshControl } from 'react-native-gesture-handler'
import { withUnistyles } from 'react-native-unistyles'

import { Theme, ThemeColorName } from '@/styles/theme'

const BaseRefreshControl = withUnistyles(RefreshControl)

export type UniRefreshControlProps = RefreshControlProps & {
  colorName?: ThemeColorName
  getThemeProps?: (theme: Theme) => Partial<RefreshControlProps>
}

const UniRefreshControl = ({
  colorName,
  getThemeProps,
  ...rest
}: UniRefreshControlProps) => {
  return (
    <BaseRefreshControl
      {...rest}
      uniProps={(theme) => {
        const color = colorName ? theme.colors[colorName] : undefined

        return {
          ...(color
            ? {
                colors: rest.colors ?? [color],
                tintColor: rest.tintColor ?? color,
              }
            : {}),
          ...getThemeProps?.(theme),
        }
      }}
    />
  )
}

export default UniRefreshControl
